import { render, staticRenderFns } from "./DeletePigs.vue?vue&type=template&id=75222f3d"
import script from "./DeletePigs.vue?vue&type=script&setup=true&lang=js"
export * from "./DeletePigs.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports